export default (store) => store.createEmbededEntityState({
  attrs: ['contract_id', 'platform_specific_licence_period_flg',
    'attribute_1', 'attribute_2', 'note', 'delivered_date'],
  titles: [
    store.__('contract'),
    store.__('minimum guarantee'),
    store.__('attribute 1'),
    store.__('attribute 2'),
    store.__('note'),
    store.__('delivered date')
  ],
  _sortField: 'contract_id',
  initVals: (row) => ({ control_timestamp: Math.round(new Date().getTime()) }),
  validators: {
    _global: (vals) => {
      if (store.cv.record.get('contract') &&
         store.cv.record.get('contract').length > 0 &&
         vals.get('control_timestamp') !== store.cv.record.get('contract')[0].control_timestamp) {
        return [store.__('You can not chose more than 2 contracts')]
      }
    }
  }
})
